import {Component, Input, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {CommonModule} from "@angular/common";
import {UserRequestsTableComponent} from "./user-requests-table/user-requests-table.component";
import {UserRequestsAcceptComponent} from "./user-requests-accept/user-requests-accept.component";
import {UserRequestsRejectComponent} from "./user-requests-reject/user-requests-reject.component";
import {
  UserRequestsPartialAcceptComponent
} from "./user-requests-partial-accept/user-requests-partial-accept.component";
import {UserRequestsViewComponent} from "./user-requests-view/user-requests-view.component";
import {UserRequest} from "../../../model/UserRequest";
import {FaqCategory} from "../../../model/FaqCategory";
import {UserService} from "../../../services/user.service";
import {FaqCategoryService} from "../../../services/faq-category.service";

@Component({
    selector: 'app-user-requests',
    imports: [
        CommonModule,
        UserRequestsTableComponent,
        UserRequestsViewComponent,
        UserRequestsAcceptComponent,
        UserRequestsRejectComponent,
        UserRequestsPartialAcceptComponent,
    ],
    templateUrl: './user-requests.component.html',
    styleUrls: ['./user-requests.component.css']
})
export class UserRequestsComponent implements OnInit {

  @Input()
  requests: Observable<UserRequest[]>;
  categories: FaqCategory[] = [];
  crmUrl: Observable<string>;

  toView: UserRequest;
  toReject: UserRequest;
  toPartialAccept: UserRequest;
  toAccept: UserRequest;

  constructor(private userRequestService: UserService,
              private faqCategoryService: FaqCategoryService) {
  }

  ngOnInit(): void {
    this.faqCategoryService.getObjects().subscribe(categories => {
      this.categories = categories;
    });
    this.crmUrl = this.userRequestService.getCrmUrl();
  }

  handleRequest(ur: UserRequest): void {
    this.userRequestService.takeRequest(ur).subscribe(u => {
      ur.handledBy = u.handledBy;
    });
  }

  untakeRequest(ur: UserRequest): void {
    this.userRequestService.untakeRequest(ur).subscribe(() => {
      ur.handledBy = null;
    });
  }

  doAccept(values): void {
    this.toAccept.accepted = true;
    this.userRequestService.acceptRequest(this.toAccept).subscribe(() => {
      this.toAccept.accepted = true;
    });
  }

  doPartialAcceptRequest(values): void {
    this.toPartialAccept.rejectReason = values.rejectReason;
    this.userRequestService.partialAcceptRequest(this.toPartialAccept).subscribe(() => {
      this.toPartialAccept.accepted = true;
      this.toPartialAccept.partial = true;
    });
  }

  doReject(values): void {
    this.toReject.rejectReason = values.rejectReason;
    this.userRequestService.rejectRequest(this.toReject).subscribe(() => {
         this.toReject.accepted = false;
    });
  }
}
